module.exports = __webpack_public_path__ + "static/media/ban-no-item.e791a490.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/ban-no-item.png
// module id = 93
// module chunks = 6